// Stripe price IDs differ between live and test mode.
// Set REACT_APP_STRIPE_TEST=true to use test-mode prices (local testing with test keys).
const useTestPrices = process.env.REACT_APP_STRIPE_TEST === 'true';

const priceIds = useTestPrices
  ? {
      monthly: 'price_1ROmMCH024do87DzCJQz1Fmr',
      quarterly: 'price_1ROmMCH024do87DzKUfa1Jg0',
      semiannual: 'price_1ROmMCH024do87DzY2cnLn12',
      annual: 'price_1ROmMCH024do87DzoyEQaF8z'
    }
  : {
      monthly: 'price_1TDB9kHqnsvGU54Y22QY9l9Q',
      quarterly: 'price_1TDB9iHqnsvGU54Yb2MPIJ0X',
      semiannual: 'price_1TDB9jHqnsvGU54YYrNL6rLg',
      annual: 'price_1TDB9kHqnsvGU54YZLwdptgp'
    };

export const stripePlans = {
  monthly: {
    priceId: priceIds.monthly,
    name: 'Monthly',
    price: '$119.99/mo'
  },
  quarterly: {
    priceId: priceIds.quarterly,
    name: 'Quarterly',
    price: '$109.99/mo',
    savings: 'Save $29.98'
  },
  semiannual: {
    priceId: priceIds.semiannual,
    name: 'Semi-Annual',
    price: '$99.99/mo',
    savings: 'Save $119.95'
  },
  annual: {
    priceId: priceIds.annual,
    name: 'Annual',
    price: '$999.99/yr',
    savings: 'Save $439.89'
  }
};

export default stripePlans;
